
    import * as React from 'react';

    const Zoom48 = ({ color = 'currentcolor', height = '48px', width = '48px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 48 48" xmlnsXlink="http://www.w3.org/1999/xlink" style={svgStyle}><desc>{"Created with Sketch."}</desc><g id="Zoom_48_svg__Icons/Zoom/48" stroke="none" strokeWidth={1} fillRule="evenodd"><g transform="translate(3.000000, 3.000000)" fillRule="nonzero"><path d="M21,42 C32.5979797,42 42,32.5979797 42,21 C42,9.40202025 32.5979797,0 21,0 C9.40202025,0 0,9.40202025 0,21 C0,32.5979797 9.40202025,42 21,42 Z M21,41 C9.954305,41 1,32.045695 1,21 C1,9.954305 9.954305,1 21,1 C32.045695,1 41,9.954305 41,21 C41,32.045695 32.045695,41 21,41 Z" id="Zoom_48_svg__Oval" /><path d="M21.5,20.5 L31,20.5 L31,21.5 L21.5,21.5 L21.5,31 L20.5,31 L20.5,21.5 L11,21.5 L11,20.5 L20.5,20.5 L20.5,11 L21.5,11 L21.5,20.5 Z" id="Zoom_48_svg__Combined-Shape" /></g></g></svg>
        </div>
      );
    };

    Zoom48.displayName = 'Zoom48';

    export default Zoom48;
  